/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceProvider } from './resourceProvider';
import { RemediateResourceParamsSpec } from './remediateResourceParamsSpec';
import { ResourceCategory } from './resourceCategory';


export interface ResourcesTenantOnboardSpec { 
    resource_id: string;
    category?: ResourceCategory;
    provider: ResourceProvider;
    metadata?: object;
    /**
     * Any comment related to resource to be onboarded.
     */
    note?: string;
    params?: RemediateResourceParamsSpec;
}
export namespace ResourcesTenantOnboardSpec {
}


